<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="justify-content-start mb-5">
          <b-col cols="4" lg="2" xl="1">
            <back-button :returnUrl="returnUrl"></back-button>
          </b-col>
        </b-row>
        <spinner v-if="activateSpinner"></spinner>
        <biconus-form :mode="mode" :readonly="!isEditable" v-model="config" v-else></biconus-form>
        <b-row class="justify-content-end">
          <b-col cols="4" lg="2" xl="1" v-if="isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="switchMode('details')">
              <span>{{ $t('common.cncl') }}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="!isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="switchMode('edit')">
              <i class="fa-light fa-pencil"></i>
              <span>{{ $t('administration.edit') }}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="!isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="deleteBICOnus">
              <i class="fa-light fa-trash"></i>
              <span>{{ $t('rights.delete') }}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="editBICOnus">
              <i class="fa-light fa-save"></i>
              <span>{{$t('common.sve')}}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="mode === 'add'">
            <b-button variant="primary"
              @click="addBICOnus">
              <i class="fa-light fa-save"></i>
              <span>{{$t('common.sve')}}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'
import {loadPage} from '@/helpers/routing'
import BICOnusForm from "@/pages/biconus/BICOnusForm.vue";

export default {
  Name: "BICDetails",
  components: {
    'back-button': backButton,
    'biconus-form': BICOnusForm,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  props: {
    mode: {
      type: String,
      default: "add"
    },
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    isEditable () {
      return this.formType === 'add' || this.formType === 'edit'
    },
    pageTitle() {
      switch (this.mode) {
        case 'edit':
          return this.$t('Webheader.bic_onus_edit')
        case 'details':
          return this.$t('Webheader.bic_onus_details')
        case 'add':
        default:
          return this.$t('Webheader.bic_onus_add')
      }
    }
  },
  data() {
    return {
      activateSpinner: false,
      alerts: '',
      returnUrl: '',
      currentBICOnus: {},
      savedConfig: [],
      config: {},
      originalConfig: {},
      formType: 'add'
    }
  },
  created() {
    this.activateSpinner = true
    this.formType = this.mode

    this.returnUrl = '/biconus/'

    if(this.id !== '-1' && (this.mode === "details" || "edit")) {
      this.getBICOnus()
    } else {
      this.activateSpinner = false
    }
  },
  methods: {
    addBICOnus () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let params = {
        BIC: this.config.BIC
      }
      this.$engine.bic.bic.createOnus(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.bic.bic_onus_added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/biconus/'})
      })
      .catch(e => {
        if (e.response.status === 400 && e.response.data.errors) {
          const errors = e.response.data.errors

          errors.forEach((error) => {
            if (error.error === "BIC Exist") {
              that.okMessageBox(that.$t('common.bic.bic_exist'))
            }
          })
        } else {
          errorMessageAlert(e, that, that.$i18n)
        }
      })
    },
    deleteBICOnus () {
      let that = this
      this.$f7.modal({
        title: this.$t('common.bic.element_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdBICOnus: that.id
              }
              that.$engine.bic.bic.deleteOnus(params)
              .then(resp => {
                that.$f7.modal({
                  title: that.$t('common.bic.bic_onus_deleted'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                loadPage(that, {url: '/biconus/'})
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('common.bic.bic_onus_delete_error'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editBICOnus () {

      if (this.formHasError()) {
        return
      }

      let that = this
      let params = {
        BIC: this.config.BIC,
        IdBICOnus: this.id
      }
      this.$engine.bic.bic.editOnus(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.bic.bic_onus_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/biconus/'})
      })
      .catch(e => {
        if (e.response.status === 400 && e.response.data.errors) {
          const errors = e.response.data.errors

          errors.forEach((error) => {
            if (error.error === "BIC Exist") {
              that.okMessageBox(that.$t('common.bic.bic_exist'))
            }
          })
        } else {
          errorMessageAlert(e, that, that.$i18n)
        }
      })
    },
    fillFields () {
      this.config = this.currentBICOnus
      this.originalConfig = this.currentBICOnus
      this.activateSpinner = false
    },
    formHasError () {

      const bicRegex = /^[A-Za-z]{6,6}[A-Za-z2-9][A-NP-Za-np-z0-9]([A-Za-z0-9]{3,3}){0,1}?$/

      if (this.config.BIC === undefined || this.config.length === 0) {
        this.okMessageBox(this.$t('common.bic.BIC_missing'))
        return true
      }

      if (!bicRegex.test(this.config.BIC)) {
        this.okMessageBox(this.$t('common.bic.BIC_invalid'));
        return true;
      }

      return false
    },
    getBICOnus () {
      this.$engine.bic.bic.fetchOnus({id: this.id})
      .then(resp => {
        let that = this
        let bicList = {}

        bicList = resp.data.BICOnus

        that.updateBic(bicList)
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    switchMode (mode) {
      if (mode === 'details' && this.formType === 'edit') {
        this.config = this.originalConfig
      }
      this.formType = mode
    },
    updateBic(BICList){
      const selectedAlerts = BICList.find(alerts => alerts.IdBICOnus === this.id)
      this.currentBICOnus = selectedAlerts
      this.fillFields()
    }
  }
}
</script>
